import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingCropPlantProtection, setFootprintingCropPlantProtectionAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_CROP, FOOTPRINTING_FARM_CROP_PLANT_PROTECTION } from "consts";

import { FootprintingFarmCropPlantProtectionPayload } from "models";

export const useMutateFootprintingFarmCropPlantProtection = (
  farmId: string,
  cropId: string,
  year: number,
  payload: FootprintingFarmCropPlantProtectionPayload,
  primaryDataId?: string
) => {
  const queryClient = useQueryClient();
  const isAdmin = getEnvironment().admin;
  const queryFn = isAdmin ? setFootprintingCropPlantProtectionAdmin : setFootprintingCropPlantProtection;
  return useMutation(
    {
      mutationKey: [FOOTPRINTING_FARM_CROP_PLANT_PROTECTION],
      mutationFn: () => queryFn(payload, primaryDataId),
      onSuccess: async () => {
        const QKs = [
          [FOOTPRINTING_FARM_CROP_PLANT_PROTECTION, primaryDataId],
          [FOOTPRINTING_CROP, farmId, cropId, year],
        ];
        await Promise.all(QKs.map((QK) => queryClient.invalidateQueries({ queryKey: QK })));
        await Promise.all(QKs.map((QK) => queryClient.refetchQueries({ queryKey: QK })));
      },
    },
    queryClient
  );
};
